import createAxiosThunk from 'store/createAxiosThunk';

import { specialtiesUrl as selectSpecialtiesUrl } from 'store/fusionServices/selectFusion';
import { axiosInstance } from '../config/selectAxios';
import { SPECIALTIES_SLICE_NAME } from '../slicesNames';

// eslint-disable-next-line import/prefer-default-export
export const fetchSpecialties = createAxiosThunk(
  `${SPECIALTIES_SLICE_NAME}/fetch`,
  async (args, thunkApi) => {
    const { getState } = thunkApi;

    const state = getState();
    const axios = axiosInstance(state);

    // get service url
    const url = selectSpecialtiesUrl(state);
    const urlObj = new URL(url);

    // append network slug if it was passed as an arg
    const { networkSlug } = args || {};
    if (networkSlug) urlObj.searchParams.set('network_slug', networkSlug);

    const response = await axios.get(urlObj.toString());
    return response.data;
  }
);
